import script from "./iptvDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./iptvDetail.vue?vue&type=script&lang=ts&setup=true"

import "./iptvDetail.vue?vue&type=style&index=0&id=cadc622a&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cadc622a"]])

export default __exports__